export default __webpack_public_path__ + "9b03d3411bf957724de17f9ad87f443b.png";